module.exports = __webpack_public_path__ + "assets/img/KRUG_BRASIL__0705-min.d5239bc4.jpg";